import { useRef, useEffect } from 'react';
import { TextField, type TextFieldProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import isTouchDevice from '@/lib/utils/isTouchDevice';

type PromptTextFieldProps = Omit<
  TextFieldProps,
  'variant' | 'helperText' | 'error' | 'inputRef' | 'autoFocus' | 'fullWidth'
> & {
  hasEmptyError: boolean;
};

const PromptTextField = ({ hasEmptyError, ...props }: PromptTextFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (hasEmptyError && inputRef.current !== null) {
      inputRef.current.focus();
    }
  }, [hasEmptyError]);

  return (
    <TextField
      variant="filled"
      helperText={
        hasEmptyError && <FormattedMessage id="prompt.errors.name_empty" />
      }
      error={hasEmptyError}
      inputRef={inputRef}
      autoFocus={!isTouchDevice()}
      fullWidth
      {...props}
    />
  );
};

export default PromptTextField;
